var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3000_5771"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Chevron",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Chevron",
    width: 16,
    height: 16,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3000_5771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.47 5.52C4.21 5.26 3.78 5.26 3.52 5.52C3.26 5.78 3.26 6.21 3.52 6.47L7.52 10.47C7.78 10.73 8.21 10.73 8.47 10.47L12.47 6.47C12.73 6.21 12.73 5.78 12.47 5.52C12.21 5.26 11.78 5.26 11.52 5.52L8 9.05L4.47 5.52Z",
    fill: "#718EBF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropdown);
export default __webpack_public_path__ + "static/media/menu-dropdown.f1774e6bf69f3a50ab93678385195a82.svg";
export { ForwardRef as ReactComponent };